import { withStyles } from '../../tools/withStyles';
import { Component } from './Main';
import { styles } from './Main.styles';

const Main = withStyles(styles)(Component);

export { Main };

// Commit trace: 2026-01-29T00:12:42 - chore: update formatting in index.js

// Commit trace: 2026-02-06T05:44:44 - style: fix spacing in index.js
